import React, { useMemo, useState } from "react";

function getInitials(label) {
  const parts = String(label || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);

  if (!parts.length) return "U";
  return parts.map((part) => part[0]?.toUpperCase() || "").join("");
}

export default function Avatar({
  src,
  alt = "",
  className = "",
  fit = "cover",
}) {
  const [hasError, setHasError] = useState(false);
  const initials = useMemo(() => getInitials(alt), [alt]);
  const showImage = Boolean(src) && !hasError;

  return (
    <span
      className={`new-sidebar-avatar ${className} ${
        fit === "contain" ? "is-logo" : "is-photo"
      }`}
    >
      {showImage ? (
        <img src={src} alt={alt} onError={() => setHasError(true)} />
      ) : (
        <span className="new-sidebar-avatar__fallback" aria-hidden="true">
          {initials}
        </span>
      )}
    </span>
  );
}
